import parse from 'html-react-parser'
import sanitizeHtml from 'sanitize-html'

// Use sanitize-html's default allowed tags (common block and inline tags)
// Loading images are allowed, but this is a convienient way to allow them without having to specify all the other allowed tags manually.
const allowedTags = sanitizeHtml.defaults.allowedTags.concat(['img'])

const extendedAllowedTags = [
  ...sanitizeHtml.defaults.allowedTags,
  'font',
  'video',
  'audio',
  'source',
  'picture',
  'img',
  'mark',
  'u',
  's',
  'strike',
  'details',
  'summary',
  'span',
  'pre',
  'code',
  'table',
  'thead',
  'tbody',
  'tfoot',
  'tr',
  'td',
  'th',
  'blockquote',
]

/**
 * Safely parses HTML, escaping only unknown/custom tags.
 * Allowed tags are left intact; only the tag brackets of disallowed tags are escaped (content is preserved).
 * Note: This uses a regex for tag matching, which may not cover all edge cases of HTML.
 */
export default function safeParse(html, extendedTags = false) {
  if (typeof html !== 'string') return html
  // Regex to match all HTML tags (simple, not exhaustive)
  const tagRegex = /<\/?([a-zA-Z0-9_-]+)(\s[^>]*)?>/g
  // Replace only tags not in allowedTags
  const safeHtml = html.replace(tagRegex, (match, tagName) => {
    const lowerTag = tagName.toLowerCase()
    if ((extendedTags ? extendedAllowedTags : allowedTags).includes(lowerTag)) {
      return match // Leave allowed tags as-is
    }
    // Escape only the tag brackets of unknown/custom tags
    return match.replace('<', '&lt;').replace('>', '&gt;')
  })
  // If the result is just plain text (no tags), return as string
  if (!safeHtml.match(tagRegex)) {
    return safeHtml
  }
  return parse(safeHtml)
}
